import { useEffect, useState } from 'react'

import './styles.scss'

function Component({ channelId, setChannelId, channelIds }) {
    const [items, setItems] = useState([])

    useEffect(() => {
        getData()
    }, [channelId])

    async function getData() {
        try {
            if (channelId) {
                const response = await fetch(`https://rsa-marketing.fly.dev/api/v2/news?channelIds=${channelId}`)
                let data = await response.json()
                
                if (data && data.length) {    
                    setItems(data)
                } else {
                    setItems([])
                }
            } else {
                console.log('no channel id')
            }
        } catch (error) {
            console.log('error', error)
        }
    }

    return (
        <>
            <div className="listing">
                <div className="container">
                    {
                        false &&
                        <select name="channel" id="channel" onChange={(e) => { setChannelId(e.target.value) }}>
                            <option value="en" selected={channelId === channelIds['en']}>English</option>
                            <option value={'no'} selected={channelId === channelIds['no']}>Norway</option>
                            <option value={'se'} selected={channelId === channelIds['se']}>Sweden</option>
                            <option value={'dk'} selected={channelId === channelIds['dk']}>Denmark</option>
                            <option value={'fi'} selected={channelId === channelIds['fi']}>Finland</option>
                            <option value={'pl'} selected={channelId === channelIds['pl']}>Poland</option>
                            <option value={'de'} selected={channelId === channelIds['de']}>Germany</option>
                        </select>
                    }

                    <div className="listingInner grid">
                        {
                            items.map((item, index) => {
                                return (
                                    <a href={`?id=${item.id}`} key={index} className='listingItem'>
                                        <img src={item?.mainImage?.normal} alt="" />
                                        <h2>{item.title}</h2>
                                        <div className="readMore">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
                                            </svg>
                                        </div>
                                    </a>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default Component